import { Dialog, DialogClose, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "components/app/dialog/dialog";
import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";

export default function DialogShowUserPosts({ user }: { user: any }) {
  return (
    <Dialog>
      <DialogTrigger className="flex">
        <p className="mr-1">{user?.no_of_post}</p>
        <p>Posts</p>
      </DialogTrigger>
      <DialogContent isShowBtnXClose={false}>
        <DialogHeader>
          <DialogTitle className="flex justify-center">
            <ImageUrlProfile className="rounded-full w-[200px] border shadow-md" user={user} isLinkProfile={true} />
          </DialogTitle>
          <h5 className="text-center font-bold">Total Posts</h5>
          <DialogDescription className="text-center font-semibold">
            {user?.name} posted {user?.no_of_post} contents
          </DialogDescription>
          <DialogClose>
            <button className="w-full bg-blue-500 text-white py-2 rounded-lg mt-2">Ok</button>
          </DialogClose>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
